import { apiFetch } from "../utils/api";

export const getLatestReadings = async (deviceId) => {
  const res = await apiFetch(`/api/readings/latest/${deviceId}`);
  if (!res.ok) throw new Error(`Failed to fetch latest readings for device ${deviceId}`);
  return res.json();
};

export const getFilteredReadings = async ({ deviceIds, elementIds, from, to, periodicity }) => {
  const res = await apiFetch("/api/readings/filter", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ deviceIds, elementIds, from, to, periodicity }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error || "Error fetching filtered readings");
    err.status = res.status;
    throw err;
  }

  return res.json();
};

export const getPollutionRose = async ({
  deviceIds,
  elementId,
  startDate,
  endDate,
  type = "pollution-rose",
  anemometerDeviceId,
  periodicity,
  breaks,
}) => {
  const res = await apiFetch("/api/wind-graphs/pollution-rose", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      deviceIds,
      elementId,
      startDate,
      endDate,
      type,
      anemometerDeviceId,
      periodicity,
      breaks,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error || "Error fetching pollution rose data");
    err.status = res.status;
    throw err;
  }

  return res.json();
};
